export default "__VITE_ASSET__BKj4n_hD__"